import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { interval, Subscription } from 'rxjs';
import { LogoutWarningResolution } from '../../../models/logout-warning.enum';
import { ProgressBar } from 'primeng/progressbar';
import { ButtonDirective } from 'primeng/button';

@Component({
  selector: 'cmg-clear2-ui-logout-warning',
  templateUrl: './logout-warning.component.html',
  styleUrls: ['./logout-warning.component.scss'],
  imports: [ProgressBar, ButtonDirective],
})
export class LogoutWarningComponent implements OnInit, OnDestroy {
  _dialogService = inject(DialogService);
  _ref = inject(DynamicDialogRef);
  private readonly _config = inject(DynamicDialogConfig);

  logoutTimer$: Subscription; // Holds the countdown obserable
  totalTimeSeconds = 5 * 60; // Log out after this many seconds
  countDownSeconds: number;
  countDownMinutes: number;
  countDownPercent = 100;
  private _sub = new Subscription();

  ngOnDestroy(): void {
    this._sub.unsubscribe();
  }

  ngOnInit(): void {
    this.totalTimeSeconds = this._config?.data?.totalTimeSeconds ?? this.totalTimeSeconds;
    this.countDownSeconds = this.totalTimeSeconds;
    this.countDownMinutes = this.totalTimeSeconds / 60;

    // Create a timer obserable that counts down seconds
    this._sub.add(
      (this.logoutTimer$ = interval(1000).subscribe(() => {
        if (this.countDownSeconds && this.countDownSeconds > 1) {
          this.countDownSeconds = this.countDownSeconds - 1;
          this.countDownMinutes = Math.ceil(this.countDownSeconds / 60);
          this.countDownPercent = (this.countDownSeconds / this.totalTimeSeconds) * 100;
        } else {
          this._ref.close(LogoutWarningResolution.Logout);
        }
      })),
    );
  }

  onClickLogout() {
    this._ref.close(LogoutWarningResolution.Logout);
  }

  onClickExtendSession() {
    this._ref.close(LogoutWarningResolution.ExtendSession);
  }
}
